import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('pharaoh_tomb', {
  cherry: 'oil_lamp',
  lemon: 'hieroglyph_tablet',
  orange: 'shabti',
  bell: 'bastet_cat',
  star: 'mummy_wild',
  seven: 'sarcophagus_lid',
  gem: 'buried_gem',
  scatter: 'tomb_door_scatter',
  money: 'grave_goods',
});

/** Pharaoh's Tomb — GENERATED by scaffoldSlot from
 *  content/slots/pharaoh_tomb.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const PHARAOH_TOMB_THEME: Theme = {
  id: 'pharaoh_tomb',
  name: 'Pharaoh\'s Tomb',
  palette: {
    accent: 0xc2945a,
    secondary: 0x8a6b4a,
    warm: 0xffd08a,
    frameFill: 0x231a12,
    bgGradientTop: 0x2a2016,
    bgGradientBottom: 0x0d0905,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Oil Lamp', glyph: '🪔', tint: 0xE8A23A, weight: 5, textureAlias: 'pharaoh_tomb:cherry',
        winVideoAlias: 'pharaoh_tomb:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Glyph Tablet', glyph: '📜', tint: 0xC9A86A, weight: 5, textureAlias: 'pharaoh_tomb:lemon',
        winVideoAlias: 'pharaoh_tomb:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Shabti', glyph: '🗿', tint: 0x4FA0C8, weight: 4, textureAlias: 'pharaoh_tomb:orange',
        winVideoAlias: 'pharaoh_tomb:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Sacred Cat', glyph: '🐈', tint: 0xE0A52E, weight: 3, textureAlias: 'pharaoh_tomb:bell',
        winVideoAlias: 'pharaoh_tomb:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Mummy', glyph: '🧟', tint: 0xEDE0C0, weight: 2, textureAlias: 'pharaoh_tomb:star',
        winVideoAlias: 'pharaoh_tomb:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Stone Lid', glyph: '⚰️', tint: 0xC2945A, weight: 2, textureAlias: 'pharaoh_tomb:seven',
        winVideoAlias: 'pharaoh_tomb:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Buried Gem', glyph: '💎', tint: 0x2E78B0, weight: 2.5, textureAlias: 'pharaoh_tomb:gem',
        winVideoAlias: 'pharaoh_tomb:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Tomb Door', glyph: '🚪', tint: 0x8A6B4A, weight: 0.5, textureAlias: 'pharaoh_tomb:scatter',
        winVideoAlias: 'pharaoh_tomb:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Grave Goods', glyph: '🪙', tint: 0xC2945A, weight: 1, textureAlias: 'pharaoh_tomb:money',
        winVideoAlias: 'pharaoh_tomb:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x231a12, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xc2945a, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffd08a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x8a6b4a, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xc2945a, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffd08a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffd08a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x231a12, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x8a6b4a, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xc2945a, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffd08a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xffd08a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'pharaoh_tomb:bg', path: 'environment/pharaoh_tomb.png' },
      columnBackground: { alias: 'pharaoh_tomb:column_bg', path: 'reel/pharaoh_tomb_column_bg.png' },
      border: { alias: 'pharaoh_tomb:border', path: 'brand/border_egypt.png' },
    },
  },
};
